module.exports = __webpack_public_path__ + "img/b1-5.25d72f8.png";